const IconWarning = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z'
        fill='#E6B558'
      />
      <path
        d='M7.11111 4.88889C7.11111 4.39797 7.50908 4 8 4C8.49092 4 8.88889 4.39797 8.88889 4.88889V8.44444C8.88889 8.93536 8.49092 9.33333 8 9.33333C7.50908 9.33333 7.11111 8.93536 7.11111 8.44444V4.88889Z'
        fill='white'
      />
      <path
        d='M8.88889 11.1111C8.88889 11.602 8.49092 12 8 12C7.50908 12 7.11111 11.602 7.11111 11.1111C7.11111 10.6202 7.50908 10.2222 8 10.2222C8.49092 10.2222 8.88889 10.6202 8.88889 11.1111Z'
        fill='white'
      />
    </svg>
  );
};

export default IconWarning;
